import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import List from './List';

const styles = css`
  @media (min-width: 992px) {
    height: 100%;
    display: flex;
  }
  .CommunityResults_listWrapper {
    width: 100%;
  }
  .CommunityResults_mapWrapper {
      display: block;
      width: 100%;
      height: 100%;
  }
`;

function CommunityResults({ communityList, sort, isSold }) {
  return (
    <div className={styles}>
      <List className="CommunityResults_listWrapper" communities={communityList} sort={sort} small={isSold} />
    </div>
  );
}

CommunityResults.propTypes = {
  communityList: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  isSold: PropTypes.bool,
};
CommunityResults.defaultProps = {
  isSold: false,
};
export default CommunityResults;



// WEBPACK FOOTER //
// ./src/pages/Communities/Results.js